
const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/9c863003ff2a45a7fdb4b616e355a476/83a4210232d56303cd212f2c5e8ac070.png" 
              alt="ProArk Haven Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Adult Day Care and Recreation Center where we believe every day is an opportunity to celebrate life with joy and dignity. Providing professional care, social connection, and meaningful activities for seniors.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('activities')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Activities
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
              <li>
                <a 
                  href="https://proarkhavenfoundation.ca"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Foundation
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-1">
                  <i className="ri-map-pin-line text-orange-400"></i>
                </div>
                <div className="text-gray-300 text-sm">
                  222 McIntyre Street West, #510B<br />
                  North Bay, Ontario P1B 2Y8
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-line text-orange-400"></i>
                </div>
                <span className="text-gray-300 text-sm">705.667.1780</span>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-line text-orange-400"></i>
                </div>
                <span className="text-gray-300 text-sm">admin@proarkhaven.ca</span>
              </div>
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-1">
                  <i className="ri-time-line text-orange-400"></i>
                </div>
                <div className="text-gray-300 text-sm">
                  Mon-Fri: 7AM-6PM<br />
                  Sat: 8AM-4PM
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 ProArk Haven Adult Day Care and Recreation Center. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
